import React from "react";
import "./campaign info.css";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon,MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import "react-rater/lib/react-rater.css";
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { setUser } from "../../redux/actions/AuthActions";
import { hasValue } from "../../validations/validations";
import { message, Image, Popconfirm, TreeSelect,Empty } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Skeleton from 'react-loading-skeleton';
import { Info, Delete } from '@material-ui/icons';

const { TreeNode } = TreeSelect;

class campaignInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    name_en: this.props.location.state ? this.props.location.state.data.name_en ? this.props.location.state.data.name_en : '' : '',
    name_ar: this.props.location.state ? this.props.location.state.data.name_ar ? this.props.location.state.data.name_ar : '' : '',
    description_ar: this.props.location.state.data.description_ar,
    description_en: this.props.location.state.data.description_en,
    id: this.props.location.state.data.id,
    brokersCount: this.props.location.state.data.brokersCount,
    leadsCount: this.props.location.state.data.leadsCount,
    whatsappNumber: this.props.location.state.data.whatsappNumber,
    project: this.props.location.state.data.project ? this.props.location.state.data.project.id : null,
    img: null,
    imgName: '',
    imgType: 'url',
    receipt:null,
    receiptName:'',
    receiptType:'data',
    brokerPhone:'',
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    projects: [],
    members:[],
    modal:false
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    this.getProjects()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getCampaignBrokers(1)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getCampaignBrokers = (page) => {
    axios.get(`${BASE_END_POINT}campaigns/${this.state.id}/members/get?page=${page}`, {
        headers: {
            'Authorization': `Bearer ${this.props.currentUser.token}`,
            'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        }
    }).then(response => {
        console.log("brokers   ", response.data)
        this.setState({ 
          members: response.data.data ,
          page:response.data.page,
          pages:response.data.pageCount,
          loading:false,
        })
    })
    .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
    })
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/shortList/get?all=true`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  update = () => {
    const { name_en, img, name_ar, imgType, description_en, description_ar,company, project, whatsappNumber } = this.state
    if (hasValue(name_en) && hasValue(name_ar) && hasValue(description_en) && hasValue(description_ar)
      && hasValue(whatsappNumber) && project != null) {
      let l = message.loading('Wait..', 2.5)
      var data = new FormData()
      data.append('name_en', name_en)
      data.append('name_ar', name_ar)
      data.append('description_en', description_en)
      data.append('description_ar', description_ar)
      data.append('whatsappNumber', whatsappNumber)
      data.append('project', project)
      if (img !== null && imgType === "data") {
        data.append(`img`, img)
      }

      console.log(Array.from(data))

      axios.put(`${BASE_END_POINT}campaigns/${this.props.location.state.data.id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.props.currentUser.token}`
        },
      })
        .then(response => {
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.push('/campaigns')
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  joinCampaign = () => {
    const { receipt,brokerPhone } = this.state
    let l = message.loading('Wait..', 2.5)
    if( receipt == null){
      l.then(() => message.error(allStrings.receiptRequired, 2.5))
      return
    }
    if (hasValue(brokerPhone) &&  receipt != null) {
      var data = new FormData()
      data.append('phone', brokerPhone)
      data.append('receipt', receipt)
      console.log(Array.from(data))

      axios.post(`${BASE_END_POINT}campaigns/${this.props.location.state.data.id}/join`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.props.currentUser.token}`
        },
      })
        .then(response => {
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.push('/campaigns')
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  removeMember = (brokerId) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}campaigns/${this.props.location.state.data.id}/remove/${brokerId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response => {
      l.then(() => message.success(allStrings.done, 2.5))
      this.getCampaignBrokers()
    })
    .catch(error => {
      console.log(error.response)
      l.then(() => message.error(allStrings.error, 2.5))
    })
  }
  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}campaigns/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response => {
      l.then(() => message.success(allStrings.done, 2.5))
      this.props.history.goBack()
    })
    .catch(error => {
      console.log(error.response)
      l.then(() => message.error(allStrings.error, 2.5))
    })
  }

  submitHandler = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.update()
  };
  changeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  
  imageSection = () => {
    return (
      <MDBCol xl="4" lg="5" md="12" sm="12">
        <div className="infoCard">
          <div style={{ width: "100%", padding: '10px' }}>
            <Image
              width="100%"
              style={{ borderRadius: '6px', width: "100%", height: '280px' }}
              src={this.state.imgType === "data" ? URL.createObjectURL(this.state.img) : this.props.location.state.data.img}
            />
          </div>
          <Tooltip title={allStrings.areYouSureDelete} placement="top" arrow>
            <Popconfirm okText={allStrings.yes} cancelText={allStrings.no}
              onConfirm={() => {
                this.delete()
              }}>
              <MDBBtn
                color="red"
                rounded
                style={{ borderRadius: "2px", background: 'red' }}
                className="btn-block z-depth-1a"
              >
                <MDBIcon icon="trash-alt" className="mr-2" />
                {allStrings.remove}
              </MDBBtn>
            </Popconfirm>
          </Tooltip>
        </div>
      </MDBCol>
    )
  }
  membersTable = () => {
    return (
      <MDBRow>
        <MDBCol md="12">
          <div className="infoTable">
            <div className="topInfoTable" style={{ background: '#233b5b' }}>
              <h4>
                <span class="material-icons" style={{ color: 'white', fontSize: 23 }}>group</span> {allStrings.brokers}
              </h4>
            </div>
            <div className="tableDate">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    {this.props.isRTL ?
                      <tr style={{ textAlign: 'center' }}>
                        <th scope="col">{allStrings.more}</th>
                        <th scope="col">{allStrings.receipt}</th>
                        <th scope="col">{allStrings.phone}</th>
                        <th scope="col">{allStrings.name}</th>
                        <th scope="col">#</th>
                      </tr>
                      :
                      <tr style={{ textAlign: 'center' }}>
                        <th scope="col">#</th>
                        <th scope="col">{allStrings.name}</th>
                        <th scope="col">{allStrings.phone}</th>
                        <th scope="col">{allStrings.receipt}</th>
                        <th scope="col">{allStrings.more}</th>
                      </tr>
                    }
                  </thead>
                  <tbody>
                    {this.state.loading ?
                      <tr style={{ height: '200px' }}>
                        <th colSpan="6" className="noData">
                          <Skeleton height={400} />
                        </th>
                      </tr>
                      :
                      this.state.members.length > 0 ?
                        this.state.members.map(val => (
                          this.props.isRTL ?
                            <tr style={{ textAlign: 'center' }}>
                              <td>
                                <span onClick={() => { this.props.history.push("userInfo", { data: val.broker }) }} style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.info} placement="top">
                                    <Info style={{ color: '#33d633' }} />
                                  </Tooltip>
                                </span>
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.areYouSureDelete}  placement="top" arrow>
                                    <Popconfirm okText={allStrings.yes} cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeMember(val.broker.id)
                                      }}>
                                        <Delete style={{ color: '#df0d0dff' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                              <td>
                                <div>
                                  <div>
                                    <a href={val.receipt} target="blank" style={{
                                      background: 'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                      color: '#fff',
                                      padding: '2px 10px',
                                      borderRadius:'50px'
                                    }}
                                    >
                                      {allStrings.openFile}
                                    </a>
                                  </div>
                                </div>
                              </td>
                              <td>{val.broker.phone}</td>
                              <th>{val.broker.fullname}</th>
                              <td>{val.broker.id}</td>
                            </tr>
                            :
                            <tr style={{ textAlign: 'center' }}>
                              <td>{val.broker.id}</td>
                              <th>{val.broker.fullname}</th>
                              <td>{val.broker.phone}</td>
                              <td>
                                <div>
                                  <div>
                                    <a href={val.receipt} target="blank" style={{
                                      background: 'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                      color: '#fff',
                                      padding: '2px 10px',
                                      borderRadius:'50px'
                                    }}
                                    >
                                      {allStrings.openFile}
                                    </a>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.info} placement="top">
                                    <Info style={{ color: '#33d633' }} />
                                  </Tooltip>
                                </span>
                                <span onClick={() => { this.removeMember(val.broker.id) }} style={{ margin: "4px", cursor: 'pointer' }}>
                                  <Tooltip title={allStrings.areYouSureDelete}  placement="top" arrow>
                                    <Popconfirm okText={allStrings.yes} cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.removeMember(val.broker.id)
                                      }}>
                                        <Delete style={{ color: '#df0d0dff' }} />
                                    </Popconfirm>
                                  </Tooltip>
                                </span>
                              </td>
                            </tr>
                        ))

                        :
                        <tr style={{ height: '200px' }}>
                          <th colSpan="6" className="noData">
                            <Empty description={allStrings.noData} style={{ margin: '0rem' }} />
                          </th>
                        </tr>
                    }
                  </tbody>
                </table>
                {this.state.members.length > 0 &&
                  <div style={{ textAlign: 'center', margin: 'auto', marginTop: '3rem' }}>
                    {this.paginationButtons()}
                  </div>
                }
              </div>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    )
  }
  paginationButtons = () => (
    <CardActions style={{ display: 'inline-flex' }}>
      <Button
        onClick={() => {
          if (this.state.page !== 1) {
            this.getCampaignBrokers(1)
            this.setState({ page: 1 })
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

      <Button
        onClick={() => {
          if (this.state.page > 1) {
            this.getCampaignBrokers(this.state.page - 1)
            this.setState({ page: this.state.page - 1 })
          }
        }}
        className="pagenation">{allStrings.prev}</Button>

      <Pagination
        onChange={(event, page) => {
          console.log("page   ", page)
          if (page !== this.state.page) {
            this.getCampaignBrokers(page)
            this.setState({ page: page })
          }

        }}
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{ color: `${'#00B483'} !important` }} />

      <Button
        onClick={() => {
          if (this.state.page < this.state.pages) {
            this.getCampaignBrokers(this.state.page + 1)
            this.setState({ page: this.state.page + 1 })
          }
        }}
        className="pagenation">{allStrings.next}</Button>

      <Button
        onClick={() => {
          if (this.state.page !== this.state.pages) {
            this.getCampaignBrokers(this.state.pages)
            this.setState({ page: this.state.pages })
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )
  fileChangedHandler = event => {
    this.setState({
      img: event.target.files[0],
      imgName: event.target.files[0].name,
      imgType: 'data'
    })
  }
  removeFile = () => {
    this.setState({
      img: null,
      imgName: '',
      imgType: "url"
    });
  }
  fileChangedHandlerReceiptFile = event => {
    this.setState({
      receipt: event.target.files[0],
      receiptName: event.target.files[0].name,
      receiptType: 'data'
    })
  }
  removeReceiptFile = () => {
    this.setState({
      receipt: null,
      receiptName: '',
      receiptType: "url"
    });
  }
  submitHandlerJoin = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.joinCampaign()
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }
  modal = () =>(
    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
      <MDBModalHeader toggle={this.toggle} >{allStrings.completeData}</MDBModalHeader>
        <MDBModalBody>
          <MDBContainer>
            <MDBRow>
              <MDBCol md="12">
                <form style={{paddingTop:'1rem'}}
                  className="needs-validation"
                  onSubmit={this.submitHandlerJoin}
                  noValidate
                >
                  <div className="grey-text">
                    <MDBRow>
                      <MDBCol md="12">
                        <div className="md-form">
                          <label htmlFor="form92" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.phone}</label>
                          <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} type="text" id="form92" className="form-control" onChange={this.changeHandler} required validate  name="brokerPhone"/>
                        </div>
                      </MDBCol>
                    </MDBRow>
                    <MDBRow>
                      <MDBCol md="12">
                        <div className="fileUpload2">
                          <input key={this.state.receipt} type='file' className="upImgs2" onChange={this.fileChangedHandlerReceiptFile} ></input>
                          <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.uploadReceipt}</span></span>
                        </div>
                        <div className="preview">
                          {this.state.receipt &&
                            <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                              <img alt="" src={this.state.receiptType === "data" ? URL.createObjectURL(this.state.receipt) : this.state.receipt} className="previewImg2" />
                              <span className="imgName">{this.state.imgName}</span>
                              <MDBIcon icon="trash" className="mr-2 removeImg2"
                                onClick={() => this.removeReceiptFile()}  ></MDBIcon>
                            </div>
                          }
                        </div>

                      </MDBCol>
                    </MDBRow>
                  </div>
                  <br></br>
                  <br></br>
                  <div className="text-center">
                    <MDBBtn type="submit" style={{ background: '#233b5b' }} rounded className="btn-block z-depth-1a" >
                      <MDBIcon className="mr-2" />
                      {allStrings.done}
                    </MDBBtn>
                  </div>
                </form>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CAMPAIGNS')) return <Redirect to='/Home' />

    return (
      <div className="App">
        <MDBContainer>
        {this.modal()}
          <MDBRow>
            <MDBCol xl={this.state.actionType === "VIEW" ? "8" : "12"} lg={this.state.actionType === "VIEW" ? "7" : "12"} md="12" sm="12">
              <div className="infoCard">
                <Card className="editCard">
                  <CardMedia style={{ height: "0px" }} />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon">
                      <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>campaign</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: this.props.isRTL ? 'inline-block' : 'inline-block', marginTop: this.props.isRTL ? '-60px' : '-60px',
                      marginLeft: this.props.isRTL ? '0' : '0', marginRight: this.props.isRTL ? '0' : '0', position: 'relative'
                    }}>
                      <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: "none" }}>
                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              {this.state.actionType === "VIEW" &&
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="md-form">
                                      <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.id} type="text" id="form8" className="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              }
                              {this.state.actionType === "VIEW" &&
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div class="md-form">
                                      <label for="form38" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.brokersCount}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.brokersCount} type="text" id="form38" name="brokersCount" class="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div class="md-form">
                                      <label for="form2" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.leadsCount}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.leadsCount} type="text" id="form2" name="leadsCount" class="form-control" />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              }
                              <MDBRow>
                                <MDBCol md="6">
                                  <div class="md-form">
                                    <label for="form38" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9#.,@%$_^*()\/\\ _-]+/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.name_ar} type="text" id="form38" name="name_ar" class="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div class="md-form">
                                    <label for="form2" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.name_en} type="text" id="form2" name="name_en" class="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="12">
                                  <div className="md-form">
                                    <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                    <br></br>
                                    <textarea value={this.state.description_en} name="description_en" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="12">
                                  <div className="md-form">
                                    <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                    <br></br>
                                    <textarea value={this.state.description_ar} name="description_ar" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form59" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.whatsapp}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} type="text" value={this.state.whatsappNumber} id="form59" name="whatsappNumber" className="form-control" onChange={this.changeHandler} required validate />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    disabled={this.state.actionType === "EDIT" ? false : true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.project}
                                    value={this.state.project}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ project: value });
                                    }}

                                  >
                                    {this.state.projects.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>
                              {this.state.actionType === "EDIT" &&
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="fileUpload2">
                                      <input key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                      <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                    </div>
                                    <div className="preview">
                                      {this.state.img &&
                                        <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine' }}>
                                          <img alt="" src={this.state.imgType === "data" ? URL.createObjectURL(this.state.img) : this.state.img} className="previewImg2" />
                                          <span className="imgName">{this.state.imgName}</span>
                                          <MDBIcon icon="trash" className="mr-2 removeImg2"
                                            onClick={() => this.removeFile()}  ></MDBIcon>
                                        </div>
                                      }
                                    </div>

                                  </MDBCol>
                                </MDBRow>
                              }
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                              {this.state.actionType === "VIEW" &&
                                <Tooltip title={allStrings.leads} placement="top">
                                  <span onClick={() => { this.props.history.push("Leads", { campaign: this.state.id }) }}
                                    className="material-icons" style={{ color: '#233b5b', fontSize: 50, cursor: 'pointer' }}>contact_phone</span>
                                </Tooltip>
                              }
                              {this.state.actionType === "VIEW" &&
                              <MDBBtn
                                rounded
                                style={{ borderRadius: "2px",background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)' }}
                                className="btn-block z-depth-1a"
                                onClick={()=>{
                                    this.toggle()
                                }}
                              >
                                {allStrings.joinCampaign}
                              </MDBBtn>
                              }
                            </div>
                            <br></br>
                            <br></br>
                            {this.state.actionType === "EDIT" &&
                              <div className="text-center">
                                <MDBBtn type="submit" style={{ background: '#233b5b' }} rounded className="btn-block z-depth-1a" >
                                  <MDBIcon icon="edit" className="mr-2" />
                                  {allStrings.update}
                                </MDBBtn>
                              </div>
                            }
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
            {this.state.actionType === "VIEW" && this.imageSection()}
          </MDBRow>
          {this.state.actionType === "VIEW" && this.membersTable()}
        </MDBContainer>
      </div>
    );
  }
}

const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchaddressrops = {
  setUser,
};

export default withRouter(
  connect(mapToStateProps, mapDispatchaddressrops)(campaignInfo)
);